<template lang="pug">
    svg.submarine-svg(
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1344.48 830.4"
        :class="glowing && 'submarine-svg--glowing'"
        v-once
    )
        div(:is="detail" v-for="detail in availableDetails" :key="detail")
</template>

<script>
    import cities from '../../../../../config/cities.json';
    import { mapState } from 'vuex';
    import Propeller from './Propeller.vue';
    import Searchlight from './Searchlight.vue';
    import Gondola from './Gondola.vue';
    import Airlock from './Airlock.vue';
    import RemoteControl from './RemoteControl.vue';
    import Periscope from './Periscope.vue';
    import SubmarineBody from './Body.vue';

    export default {
        props: ['glowing'],
        components: {
            SubmarineBody,
            Propeller,
            Airlock,
            Searchlight,
            Gondola,
            Periscope,
            RemoteControl,
            Navigator,
        },
        data() {
            return {
                details: {
                    'submarine-body': 'Tokyo',
                    airlock: 'MadagascarIsland',
                    searchlight: 'JurassicPark',
                    propeller: 'EasterIsland',
                    periscope: 'Sydney',
                    gondola: 'ResearchStationProgress',
                    navigator: 'Venus',
                },
                allDetails: [
                    'submarine-body',
                    'airlock',
                    'searchlight',
                    'propeller',
                    'periscope',
                    'gondola',
                    'navigator',
                ],
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            availableDetails() {
                return this.allDetails.filter(
                    detail => this.user.availableLocationId - 1 > cities.indexOf(this.details[detail])
                );
            },
        },
    };
</script>

<style lang="scss" scoped>
    $blue-glowing-color: #00aeff;
    .submarine-svg--glowing {
        filter: drop-shadow(0 0 100px $blue-glowing-color);
    }

    .submarine-svg {
        width: 100%;
        @media screen and (max-device-height: 440px) {
            margin-top: -2.5rem;
            transform: scale(0.7);
        }
    }
</style>
